import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const reviewProofApi = generateProofApi('/proof-file/review');
const { getProofsOptions, createOrUpdateProofOptions, deleteProofOptions } = generateProofOptions(
  'review',
  reviewProofApi,
);

export function getReviewProofsOptions(reviewId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(reviewId);
}

export function useUploadOrUpdateReviewProof(reviewId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(reviewId, queryClient));
}

export function useDeleteReviewProof(reviewId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(reviewId, queryClient));
}
